// extracted by mini-css-extract-plugin
module.exports = {"md":"list_md_1RogO","ios":"list_ios_3Ix0E","page":"list_page_BqLFm","empty":"list_empty_1xFBK"};